
function Adoption() {

  return (
    <section className="adoption-area">
      <div className="container">

      </div>
    </section>
  )
}

export default Adoption;
